<button mat-raised-button *appRole="['Bonificaciones.Crear']" color="primary" [disabled]="true" [routerLink]="['/bonificaciones']">
  <mat-icon>add</mat-icon>
  Nueva bonificación
</button>
